export enum Column {
  Title = 'Title',
  Date = 'Date',
  Children = 'Children',
  Sum = 'Sum',
  Action = 'Action'
}
